<template>
    <div class="outer">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane label="我的申领单" name="1">
                <GoodsClaim v-if="activeName === '1'" />
            </el-tab-pane>
            <el-tab-pane label="申领单审批" name="2" v-if="canApprove">
                <GoodsClaimApproval v-if="activeName === '2'" />
            </el-tab-pane>
            <el-tab-pane label="申领单出库" name="3" v-if="canOutbound">
                <GoodsClaimOutbounce v-if="activeName === '3'" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import GoodsClaim from "./components/GoodsClaim.vue";
import GoodsClaimApproval from "./components/GoodsClaimApproval.vue";
import GoodsClaimOutbounce from "./components/GoodsClaimOutbounce.vue";
import { canApproveRequest, canOutbound } from "@/views/goods/permission.js";
export default {
    data() {
        return {
            canApprove: canApproveRequest(), // 申领单审批权限（部门负责人组/总经理/CTO/事业部总监）
            canOutbound: canOutbound(), // 申领单出库权限（行政 48/31）
            activeName: '1', // 当前tab
        }
    },
    async created() {
        if (this.$route.params.applyNo && this.canOutbound) {
            this.activeName = '3';
        }
        
    },
    components: {
        GoodsClaim,
        GoodsClaimApproval,
        GoodsClaimOutbounce,
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },
}
</script>
<style lang="scss" scoped>
</style>
